import React from "react";
import { Heart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PledgeOfSupport() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="35045" id="fuel-our-future" className="relative bg-background text-foreground bg-gradient-to-br from-[hsl(43,89%,55%)] to-[hsl(255,65%,92%)] py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-[0.05]">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570824/img/diverse_children_and_families_healing.png" alt="Diverse children and families" className="w-[60%] max-w-lg object-contain grayscale" />
      </div>

      <div ref={ref} className={`relative z-10 max-w-[800px] mx-auto px-6 text-center transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-primary mb-8 font-serif tracking-tight">
          Help Us Write the Next Chapter
        </h2>

        <p className="text-primary/80 text-lg md:text-xl leading-[1.8] mb-12 font-sans">
          Every contribution creates a sanctuary where children can find hope and
          agency through creative expression. Join us in empowering families to
          tell their stories with courage, purpose, and the healing power of art
          and movement.
        </p>

        <div className="flex justify-center">
          <Button asChild className="px-10 py-8 text-lg font-semibold tracking-wide shadow-xl hover:shadow-primary/20 hover:-translate-y-1 transition-all duration-300 rounded-full bg-primary text-primary-foreground">
            <Link to="/DonorAndPartnerHubPage">
              DONATE NOW
              <Heart className="ml-2 size-5 fill-current" />
            </Link>
          </Button>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 w-full flex justify-center">
        <Separator className="w-full h-[1px] bg-primary/20" />
      </div>
    </section>;
}